<template>
	<after-sales type="return" :after-sales-number="returnNumber"></after-sales>
</template>

<script>
	import afterSales from './after_sales_detail.vue'
	
	export default {
		name: 'return_detail',
		
		components: {
			afterSales
		},
		
		props: {
			returnNumber: String
		}
	}
</script>